var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTableSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "Icon-fill-color",
    stroke: "transparent",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.25659 6C5.25659 5.58579 5.59238 5.25 6.00659 5.25H18.0066C18.4208 5.25 18.7566 5.58579 18.7566 6C18.7566 6.41421 18.4208 6.75 18.0066 6.75H6.00659C5.59238 6.75 5.25659 6.41421 5.25659 6Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "Icon-fill-color",
    stroke: "transparent",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.25659 8C6.25659 7.58579 6.59238 7.25 7.00659 7.25H17.0066C17.4208 7.25 17.7566 7.58579 17.7566 8C17.7566 8.41421 17.4208 8.75 17.0066 8.75H7.00659C6.59238 8.75 6.25659 8.41421 6.25659 8Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "Icon-fill-color",
    stroke: "transparent",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.2632 18V6H17.7632V18C17.7632 18.4142 17.4274 18.75 17.0132 18.75C16.599 18.75 16.2632 18.4142 16.2632 18Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "Icon-fill-color",
    stroke: "transparent",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.26318 18V6H7.76318V18C7.76318 18.4142 7.4274 18.75 7.01318 18.75C6.59897 18.75 6.26318 18.4142 6.26318 18Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTableSmall);
export default __webpack_public_path__ + "static/media/TableSmall.ff43afb610dc45a14743608911a11a7e.svg";
export { ForwardRef as ReactComponent };